<template>
	<div class="container" v-show="showpage">
		<div class="header_box"></div>
		
		<!--公司介绍-开始-->
		<div class="about_box">
			<h1>公司介绍</h1>
			<p>上海视翰数码科技有限公司成立于2004年，深耕医疗行业二十余年，专注医院和科室音视频系统建设、手术转播及医疗会议服务。依托先进音视频与传输技术，实现手术与课件高清录制、呈现；实现院内手术室与会议室互联互通，院外通过互联网互动交流。</p>
			<p>2026年推出视翰医学点播平台，涵盖消化内镜、呼吸内镜两个领域，为医学从业人员提供高效便捷的视频点播服务。未来公司将持续创新，以数字化技术赋能医疗场景，助力临床医师释放专业价值。</p>
			<div class="picture">
				<img src="@/assets/images/mobile/about_img.png">
			</div>
			<p>消化内镜点播平台：包含长海消化内镜空中大讲堂、东方消化内镜学术大会（OCGE)、长海消化病和消化内镜周(CHDDW)、科主任培训班等栏目。</p>
			<p>呼吸内镜点播平台：包含长海呼吸介入沙龙、呼吸内镜培训学院、上海呼吸病专题会议等栏目。</p>
			<div class="btn_box">
				<a href="https://xhm.shshtec.com">消化内镜点播平台</a>
				<a href="https://hxm.shshtec.com">呼吸内镜点播平台</a>
			</div>
		</div>
		<!--公司介绍-结束-->
		
		<!--主营业务-开始-->
		<div class="business_box">
			<h1>主营业务</h1>
			<div class="main_tab_box">
				<div v-for="(item, index) in businessList" :key="index" :class="business==index ? 'item selected':'item'" @click="businessHandle(index)">{{item}}</div>
			</div>
			<div class="content_box">
				<p>{{businessText}}</p>
				<ul v-if="business == 0">
					<li v-for="(item, index) in shijiaoList" :key="index" :class="shijiao == index ? 'selected':''" @click="shijiaoHandle(index)">
						<div class="title">{{item}}</div>
						<div class="picture_box" v-if="index == shijiao">
							<div class="picture" v-for="(item, index) in shijiaoPictureList" :key="index">
								<div class="tag">{{item.Title}}</div>
								<img :src="item.Picture">
							</div>
						</div>
					</li>
				</ul>
				<ul v-if="business == 1">
					<li v-for="(item, index) in videoList" :key="index" :class="video == index ? 'selected':''" @click="videoHandle(index)">
						<div class="title">{{item}}</div>
						<div class="picture_box" v-if="index == video">
							<div class="picture" v-for="(item, index) in videoPictureList" :key="index">
								<div class="tag">{{item.Title}}</div>
								<img :src="item.Picture">
							</div>
						</div>
					</li>
				</ul>
				<ul v-if="business == 2">
					<li>
						<div class="picture_box">
							<div class="picture" v-for="(item, index) in meetingPictureList" :key="index">
								<div class="tag">{{item.Title}}</div>
								<img :src="item.Picture">
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<!--主营业务-结束-->
		
		<!--荣誉资质-开始-->
		<div class="honor_box">
			<h1>荣誉资质</h1>
			<h2>坚实的研发与创新根基</h2>
			<h3>驱动未来的核心资产</h3>
		</div>
		<!--荣誉资质-结束-->
		
		<!--联系我们-开始-->
		<div class="contact_box">
			<h1>联系我们</h1>
			<div class="contact">
				<p><span class="left">公司名称：</span><span>上海视翰数码科技有限公司</span></p>
				<p><span class="left">联系电话：</span><span>021-52581230</span></p>
				<p><span class="left">手机：</span><span>13601788207</span></p>
				<p><span class="left">联系人：</span><span>钱先生</span></p>
				<p><span class="left">公司地址：</span><span>上海市闵行区吴中路1050号B幢913-915室</span></p>
				<div class="picture">
					<img src="@/assets/images/mobile/contact.png">
				</div>
			</div>
		</div>
		<!--联系我们-结束-->
		
		<!--底部-开始-->
		<div class="footer_box">
			<p><a href="https://www.shshtec.com/pictures/certificate/icp.jpg" target="_blank">增值电信业务经营许可证：沪B2-20260917</a></p>
			<p><a href="https://www.shshtec.com/pictures/certificate/television.jpg" target="_blank">广播电视节目制作经营许可证：(沪)字第07163号</a></p>
			<p><a href="https://www.shshtec.com/pictures/certificate/medicine.jpg" target="_blank">药品、医疗器械互联网信息服务备案凭证：沪网药械信备字〔2026〕000167号</a></p>
			<p style="margin-top: 12px;">©2011-2026上海视翰数码科技有限公司 版权所有</p>
			<p>沪ICP备17017702号</p>
		</div>
		<!--底部-结束-->
	</div>
</template>


<script>
	import { mixin } from '@/utils/mixin.js'
	export default {
		name: 'Mobile_HomePage',
		mixins:[mixin],
		data() {
			return {
				showpage: false,	//显示
				
				businessList: [
					'手术转播系统',
					'视频直播点播系统',
					'医学会议服务'
				],
				business: 0,	//主营业务，默认
				businessText: '实现诊疗室至会议室音视频一体化，采用广播级非压缩传输技术，支持多路实时录制、示教、传输及与线上专家互动交流。',	//业务介绍
				
				shijiao: -1,		//手术示教和手术转播
				shijiaoList: [
					'上海长海医院消化内镜中心',
					'上海公立医院消化内镜中心',
					'上海长海医院临床研究中心会议室',
					'国家消化内科专业医疗质量控制中心'
				],	//示教系统子类列表
				shijiaoPictureList: [],	//示教系统图片集
				
				video: -1,		//视频直播点播系统
				videoList: [
					'消化内镜',
					'呼吸内镜',
				],	//视频直播点播系统子类列表
				videoPictureList: [],	//视频直播点播系统图片集
				
				meetingPictureList: [],	//医学会议服务图片集
			}
		},
		mounted() {
		},
		created() {
			if(!this.isMobile())
			{
				window.location.href = '/'
			}
			else
			{
				this.showpage = true
				this.shijiaoHandle(0)
				this.videoHandle(0)
				this.bindMeetingPictureList()
			}
			
		},
		methods: {
			//主营业务切换
			businessHandle(index)
			{
				this.business = index
				if(this.business == 0)
				{
					this.businessText ='实现诊疗室至会议室音视频一体化，采用广播级非压缩传输技术，支持多路实时录制、示教、传输及与线上专家互动交流。'
				}
				else if(this.business == 1)
				{
					this.businessText ='专注医疗全场景直播，让每一台手术、每一场学术会议都能高清实时触达；医学视频点播平台给广大用户提供了便捷的观看服务。'
				}
				else if(this.business == 2)
				{
					this.businessText ='提供会议设备租赁与搭建、会议网站搭建、精品课程制作，及微信公众号新媒体运营服务。'
				}
			},
			//示教系统子类切换
			shijiaoHandle(index)
			{
				if(this.shijiao == index)
				{
					this.shijiao = -1
					return
				}
				
				this.shijiao = index				
				if(this.shijiao == 0)
				{
					this.shijiaoPictureList = []
					let param1 = {
						Title: '长海医院会议室',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_1_1.png'
					}
					let param2 = {
						Title: '长海医院导播机房',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_1_2.png'
					}
					let param3 = {
						Title: '上海国际会议中心',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_1_4.png'
					}					
					this.shijiaoPictureList.push(param1)
					this.shijiaoPictureList.push(param2)
					this.shijiaoPictureList.push(param3)
					
				} else if(this.shijiao == 1)
				{
					this.shijiaoPictureList = []
					let param1 = {
						Title: '会议室',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_2_1.png'
					}
					let param2 = {
						Title: '手术室摄像头安装',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_2_2.png'
					}
					let param3 = {
						Title: 'ERCP导播设备机柜',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_2_3.png'
					}					
					this.shijiaoPictureList.push(param1)
					this.shijiaoPictureList.push(param2)
					this.shijiaoPictureList.push(param3)
					
				} else if(this.shijiao == 2)
				{
					this.shijiaoPictureList = []
					let param1 = {
						Title: '会议室',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_3_1.png'
					}
					let param2 = {
						Title: '机房',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_3_2.png'
					}
					let param3 = {
						Title: '会议室',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_3_3.png'
					}					
					this.shijiaoPictureList.push(param1)
					this.shijiaoPictureList.push(param2)
					this.shijiaoPictureList.push(param3)
					
				} else if(this.shijiao == 3)
				{
					this.shijiaoPictureList = []
					let param1 = {
						Title: '本地PPT模式',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_4_1.png'
					}
					let param2 = {
						Title: '手术转播模式',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_4_2.png'
					}
					let param3 = {
						Title: '质控中心演示模式',
						Picture: 'https://www.shshtec.com/pictures/small/business_1_4_3.png'
					}					
					this.shijiaoPictureList.push(param1)
					this.shijiaoPictureList.push(param2)
					this.shijiaoPictureList.push(param3)
				}
			},
			//视频点播直播子类切换
			videoHandle(index)
			{
				if(this.video == index)
				{
					this.video = -1
					return
				}
				
				this.video = index
				if(this.video == 0)
				{
					this.videoPictureList = []
					let param1 = {
						Title: '空中大讲堂',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_1_1.png'
					}
					let param2 = {
						Title: '空中大讲堂',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_1_2.png'
					}
					let param3 = {
						Title: '学术论坛',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_1_3.png'
					}					
					this.videoPictureList.push(param1)
					this.videoPictureList.push(param2)
					this.videoPictureList.push(param3)
					
				} else if(this.video == 1)
				{
					this.videoPictureList = []
					let param1 = {
						Title: '呼吸沙龙',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_2_1.png'
					}
					let param2 = {
						Title: '培训学院',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_2_2.png'
					}
					let param3 = {
						Title: '护理年会',
						Picture: 'https://www.shshtec.com/pictures/small/business_2_2_3.png'
					}					
					this.videoPictureList.push(param1)
					this.videoPictureList.push(param2)
					this.videoPictureList.push(param3)
					
				}
			},
			//绑定医学会议服务图片
			bindMeetingPictureList()
			{
				this.meetingPictureList = []
				let param1 = {
					Title: '第十六届上海呼吸病专题会议-介入分会场',
					Picture: 'https://www.shshtec.com/pictures/small/business_3_1_1.png'
				}
				let param2 = {
					Title: '第十六届上海呼吸病专题会议-慢阻肺分会场',
					Picture: 'https://www.shshtec.com/pictures/small/business_3_1_2.png'
				}
				let param3 = {
					Title: '第十六届上海呼吸病专题会议-感染分会场',
					Picture: 'https://www.shshtec.com/pictures/small/business_3_1_3.png'
				}
				let param4 = {
					Title: '第十六届上海呼吸病专题会议-肿瘤分会场',
					Picture: 'https://www.shshtec.com/pictures/small/business_3_1_4.png'
				}
				this.meetingPictureList.push(param1)
				this.meetingPictureList.push(param2)
				this.meetingPictureList.push(param3)
				this.meetingPictureList.push(param4)
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		padding-top: 64px;
		
		.header_box {
			padding: 15px;
			height: 64px;
			background-color: #fff;
			background-position: 15px center;
			background-repeat: no-repeat;
			background-image: url(@/assets/images/mobile/logo.png);
			background-size: auto 32px;
			position: fixed;
			top: 0;
			z-index: 1000;
			width: 100%;
			box-sizing: border-box;
			box-shadow: 1px 1px 3px #eee;
		}
		
		h1 {
			font-size: 30px;
			font-weight: 500;
			text-align: center;
		}
		
		/*公司介绍*/
		.about_box {
			width: 100%;
			padding: 40px 15px;
			box-sizing: border-box;
			background-color: #F4F7FF;
			background-position: left top;
			background-repeat: no-repeat;
			background-image: url(@/assets/images/mobile/about_bg.png);
			background-size: 100% auto;
			
			
			p {
				font-size: 15px;
				line-height: 160%;
				margin-top: 30px;
			}
			p:first-child {
				margin-top: 0;
			}
			
			.picture {
				margin-top: 20px;
				
				img {
					max-width: 100%;
				}
			}
			
			.btn_box {
				margin-top: 20px;
				text-align: center;
				
				a {
					width: 45%;
					display: inline-block;
					vertical-align: middle;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background-color: #355EDD;
					color: #fff;
					font-size: 15px;
					border-radius: 5px;
					margin: 0 2%;
				}
			}
		}
		
		/*主营业务*/
		.business_box {
			padding: 50px 15px;
			box-sizing: border-box;
			
			.main_tab_box {
				display: flex;
				justify-content: space-between;
				margin-top: 20px;
				border-bottom: #eee solid 1px;
				
				.item {
					font-size: 13px;
					font-weight: 600;
					color: #666;
					padding: 10px 0;
					border-bottom: #fff solid 2px;
					-webkit-transition: all .3s ease;
				}
				.selected {
					color: #355EDD;
					border-bottom: #355EDD solid 2px;
				}
			}
			
			.content_box {
				margin-top: 20px;
				
				p {
					font-size: 14px;
					font-weight: 400;
					line-height: 150%;
				}
				
				ul,li {
					margin: 0;
					padding: 0;
					list-style: none;
				}
				ul {
					margin-top: 20px;
				}
				li {
					width: 100%;
					margin: 5px 0;
					
					.title {
						padding: 0 15px;
						height: 40px;
						line-height: 40px;
						background-color: #f5f5f5;
						color: #333;
						font-size: 14px;
						border-radius: 8px;
						background-position: right 12px center;
						background-repeat: no-repeat;
						background-size: 14px 14px;
						background-image: url(@/assets/images/mobile/arrow_down_black.png);
						-webkit-transition: all .3s ease;
					}
					
					.picture_box {
						
						.picture {
							position: relative;
						
							img {
								display: block;
								max-width: 100%;
								margin: 10px 0;
								border-radius: 8px;
							}
							
							.tag {
								position: absolute;
								bottom: 0;
								left: 0;
								width: 100%;
								background-color: #000;
								height: 36px;
								line-height: 36px;
								text-align: center;
								color: #fff;
								border-bottom-left-radius: 8px;
								border-bottom-right-radius: 8px;
								opacity: .8;
							}
						}
					}
				}
				li.selected .title {
					background-color: #4B75F8;
					color: #fff;
					background-image: url(@/assets/images/mobile/arrow_down_white.png);
				}
			}
		}
		
		/*荣誉资质*/
		.honor_box {
			padding: 40px 15px 0 15px;
			height: 391px;
			box-sizing: border-box;
			background-position: center bottom;
			background-repeat: no-repeat;
			background-size: auto 100%;
			background-image: url(@/assets/images/mobile/ryzz_bg.png);
			
			h2 {
				margin-top: 30px;
				font-size: 24px;
				color: #3E6DFF;
				text-align: center;
				font-weight: 400;
			}
			h3 {
				margin-top: 20px;
				font-size: 20px;
				color: #000;
				text-align: center;
				font-weight: 400;
			}
		}
		
		/*联系我们*/
		.contact_box {
			padding: 40px 15px 0 15px;
			
			.contact {
				margin-top: 30px;
				p {
					display: flex;
					justify-content: flex-start;
					
					span.left {
						white-space: nowrap;
					}
					
					font-size: 14px;
					line-height: 150%;
					margin: 4px 0 0 0;
				}
				p:first-child {
					margin-top: 0;
				}
			}
			.picture {
				margin-top: 20px;
				
				img {
					max-width: 100%;
				}
			}
		}
		
		/*底部*/
		.footer_box {
			padding: 20px 0;
			background-color: #000;
			
			p {				
				text-align: center;
				font-size: 12px;
				line-height: 160%;
				color: #fff;
				opacity: .5;
				
				a {
					font-size: 11px;
					color: #fff;
				}
			}
		}
	}
</style>